<template>
    <div class="c-overview-summary component">
        <span class="text--gray ">Szanowny kliencie,</span>
        <br>
        <span class="text--bigger">{{lead.first_name}} {{ lead.last_name }}</span>
        <br>
        <span class="text--gray">{{lead.email}}</span>
        <br>
        <span class="text-upper text--gray text--huge mt--2">Bardzo dziękujemy za Twoje zlecenie!</span>
        <br>
        <span class="text--gray">Niniejszym potwierdzamy, że wizyta dla pojazdu </span>
        <span class="text--bigger"> {{ lead.registration_number }} {{ lead.model_id}} <span class="text--gray">{{ lead.brand_val }}</span></span>
        <span class="text--gray"> mogła zostać pomyślnie umówiona</span>
        <br>
        <span class="text--gray">Zaplanowane przyjęcie w dniu</span>
        <span class="text--gray text--bigger"> {{ getDetepickerConfig.formatLocale.weekdaysShort[getDayofWeek(lead.date)] }},  {{ lead.date }} </span>
        <span class="text--gray"> o godz. </span>
        <span class="text--gray text--bigger">{{lead.hour}}</span>

        <div class="mb--1 mt--1" v-if="getSelectedDealer">
            <img src="@/assets/localizations.jpg" alt="Localization" class="c-overview-summary__icon">
            <h3 class="c-overview-summary__dealerName">{{ getSelectedDealer.name }}</h3>
        </div>
            <span class="text--gray">Doradca serwisowy: {{ getAddmissionTerms[lead.term_key].user_name }}</span>
        <div class="mb--5 mt--1 text--gray" v-if="lead.replacement_car_id != 0">
            Mobilność: {{ getReplacementCars.filter(e => e.id == lead.replacement_car_id? e.model : false ).map(e => e.brand+' '+e.model)[0] }}
        </div>
        <span class="text--gray mt--2">Usługi do wykonania:</span>
        <div class="flex-col--5 mt--1 mb--2 text--gray">
            <div v-for="service in getServices.filter(e => lead.services_val.includes(e.val) )" class="flex-row c-overview-summary__service">
                <div class="flex-col--1">
                    <img :src="service.icon" :alt="service.name" class="c-services__icon">
                </div>
                <div class="flex-col--9">
                    <strong>{{service.name}}</strong>
                    <br>
                    {{ service.text }}
                </div>
            </div>
        </div>
        <span class="text--gray mt--1">Komentarz</span>
        <div class="component text--gray">
            {{ lead.comment_val }}
        </div>
    </div>
</template>
<script>
    import {mapActions,mapGetters} from 'vuex';
    import lead from '../../mixins/lead.js';
    export default{
        mixins:[lead],
        computed:{
            ...mapGetters({
                getDealers:'definitions/getDealers',
                getAddmissionTerms:'definitions/getAddmissionTerms',
                getDetepickerConfig:'definitions/getDetepickerConfig',
                getReplacementCars: 'definitions/getReplacementCars',
                getServices: 'definitions/getServices'
            }),
            getSelectedDealer() { return this.getDealers.find( e => e.id == this.lead.dealer_id) }
        },
    }
</script>
<style lang="scss">
    .c-overview-summary{
        font-size: 1.25rem;
        &__icon{
            width: 24px;
            float:left;
            margin-right: .25rem;
        }
        &__dealerName{
        }
        &__service{
            font-size: 1rem;
        }
    }
</style>